// extracted by mini-css-extract-plugin
export default {"button":"button___Vsaj6","inverted":"inverted___21A7x"};